import { create } from 'zustand'
import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768

type MobileSheetState = {
  readonly open: boolean
  readonly setOpen: (open: boolean) => void
}

export const useMobileSheet = create<MobileSheetState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}))

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }
    setIsMobile(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
